import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import MenuIcon from "../assets/images/icons/menu-toggle.svg";
import { useSelector } from "react-redux";
import ModalWrapper from "./ModalWrapper";
import { APP_CONST } from "../config/const";
import { AiOutlineClose } from "react-icons/ai";
import { getNotifications } from "../redux/app/actions";
import { FaSpinner } from "react-icons/fa";
import MoonLight from "../assets/images/moon.svg";
import SunLight from "../assets/images/sunny.svg";
import AppDownload from "../assets/images/icons/social.png";
import GamesSearchModal from "../views/components/GamesSearchModal";

const Header = ({ agentCode = "" }) => {
  const { appDetails } = useSelector((state) => state.app);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState(APP_CONST.AUTH_MODAL.LOGIN);
  const location = useLocation();
  const [isClassAdded, setIsClassAdded] = useState(false);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (location.pathname === "/" && !isMobile) {
      document.body.classList.add("leftbar-opened");
    } else {
      document.body.classList.remove("leftbar-opened");
    }
  }, [location.pathname]);

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);

    setDefaultModal(modalName);
  };

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleToggleChange = () => {
    const isClassExist = document.body.classList.contains("leftbar-opened");

    if (isClassExist) {
      document.body.classList.remove("leftbar-opened");
    } else {
      document.body.classList.add("leftbar-opened");
    }
  };

  const toggleClass = () => {
    if (isClassAdded) {
      setIsClassAdded(false);
      localStorage.removeItem("isClassAdded");
      document.body.classList.remove("light-theme");
    } else {
      setIsClassAdded(true);
      localStorage.setItem("isClassAdded", true);
      document.body.classList.add("light-theme");
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee
            onMouseOver={(e) => e.target.stop()}
            onMouseOut={(e) => e.target.start()}
          >
            {websiteNotifications.map((notf, idx) => notf?.content + " ")}
          </marquee>
          <h2 onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </h2>
        </div>
      )) ||
        null}

      <header className="header beforeheader">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="leftbar_toggle me-3">
                    <Button
                      variant="primary"
                      onClick={() => handleToggleChange((s) => !s)}
                    >
                      <img src={MenuIcon} alt="toggle menu" />
                    </Button>
                  </div>
                  <div className="logo">
                    <a href="/">
                      {appDetails?.LOGO_URL ? (
                        <img
                          src={appDetails?.LOGO_URL}
                          alt="Logo"
                          height={26}
                        />
                      ) : (
                        <FaSpinner />
                      )}
                    </a>
                  </div>

                  <div className="middle-part"></div>

                  <div className="headerRight">
                    <div className="mx-2 d-md-flex d-none">
                      {" "}
                      <GamesSearchModal />{" "}
                    </div>

                    <div className="theme-btn mx-2 d-md-flex d-none">
                      <button
                        type="button"
                        className="btn"
                        onClick={toggleClass}
                      >
                        <img src={SunLight} alt="sun" className="light_theme" />
                        <img
                          src={MoonLight}
                          alt="moon"
                          className="dark_theme"
                        />
                      </button>
                    </div>

                    <div className="AppDownload d-md-block d-none">
                      <a
                        href="https://dl.dropbox.com/scl/fi/m4294wjrmho5nfujc70ij/Funn777.apk?rlkey=w4nxkgxfn2w9xa2z429wjoeof&st=k8ffyt6l&dl=0"
                        download="https://dl.dropbox.com/scl/fi/m4294wjrmho5nfujc70ij/Funn777.apk?rlkey=w4nxkgxfn2w9xa2z429wjoeof&st=k8ffyt6l&dl=0"
                      >
                        <img src={AppDownload} alt="AppDownload" />
                      </a>
                    </div>

                    <Button
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.REGISTER);
                      }}
                      className=" btn_signup"
                    >
                      Sign up
                    </Button>

                    <Button
                      onClick={() => {
                        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                      }}
                      className=" btn_signin ms-4"
                    >
                      Log in
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {showAuthModals && (
          <ModalWrapper
            defaultShow={defaultModal}
            handleClose={setShowAuthModals}
          />
        )}
      </header>
    </>
  );
};

export default Header;
